/* Gear */
import Arrow from './Gear/Arrow.svg'
// import Blind from './Gear/Blind.svg'
import Boots from './Gear/Boots.svg'
import Camp from './Gear/Camp.svg'
import Food from './Gear/Food.svg'
import Gear from './Gear/Gear.svg'
import GroundBlind from './Gear/GroundBlind.svg'
import Pack from './Gear/Pack.svg'
import TrailCam from './Gear/TrailCam.svg'
import TreeStand from './Gear/TreeStand.svg'
import Water from './Gear/Water.svg'

/* Navigation */
import Access from './Navigation/Access.svg'
import Cabin from './Navigation/Cabin.svg'
import Gate from './Navigation/Gate.svg'
import Glassing from './Navigation/Glassing.svg'
import GOHUNT from './Navigation/goHUNT.svg'
import Hazard from './Navigation/Caution.svg'
import Junction from './Navigation/Junction.svg'
import Parking from './Navigation/Parking.svg'
import Photo from './Navigation/Photo.svg'
import Shot from './Navigation/Shot.svg'
import Trail from './Navigation/Trail.svg'

/* Sign */
import Bedding from './Sign/Bedding.svg'
import Bench from './Sign/Bench.svg'
import Blood from './Sign/Blood.svg'
import Crossing from './Sign/Crossing.svg'
import FoodPlot from './Sign/FoodPlot.svg'
import FoodSource from './Sign/FoodSource.svg'
import LadderStand from './Sign/LadderStand.svg'
import Mushrooms from './Sign/Mushrooms.svg'
import PinchPoint from './Sign/PinchPoint.svg'
import PointOfInterest from './Sign/PointOfInterest.svg'
import Rub from './Sign/Rub.svg'
import Saddle from './Sign/Saddle.svg'
import Scat from './Sign/Scat.svg'
import Scrape from './Sign/Scrape.svg'
import Shed from './Sign/Shed.svg'
import Tracks from './Sign/Tracks.svg'
import Wallow from './Sign/Wallow.svg'

/* Species */
import Antelope from './Species/Antelope.svg'
import AntlerlessDeer from './Species/AntlerlessDeer.svg'
import BHSheep from './Species/BHSheep.svg'
import Bison from './Species/Bison.svg'
import BlackBear from './Species/BlackBear.svg'
import Caribou from './Species/Caribou.svg'
import Chukar from './Species/Chukar.svg'
import CowElk from './Species/ElkCow.svg'
import Coyote from './Species/Coyote.svg'
import Dog from './Species/Dog.svg'
import Duck from './Species/Duck.svg'
import Elk from './Species/Elk.svg'
import Fish from './Species/Fish.svg'
import Fishing from './Species/Fishing.svg'
import Goose from './Species/Goose.svg'
import GrizzlyBear from './Species/GrizzlyBear.svg'
import Grouse from './Species/Grouse.svg'
import Javelina from './Species/Javelina.svg'
import Llama from './Species/Llama.svg'
import Moose from './Species/Moose.svg'
import MtnGoat from './Species/MountainGoat.svg'
import MtnLion from './Species/MountainLion.svg'
import MuleDeer from './Species/MuleDeer.svg'
import Pheasant from './Species/Pheasant.svg'
import Quail from './Species/Quail.svg'
import Sasquatch from './Species/Sasquatch.svg'
import TurkeyDusting from './Species/TurkeyDusting.svg'
import TurkeyGobble from './Species/TurkeyGobble.svg'
import TurkeyHen from './Species/TurkeyHen.svg'
import TurkeyJake from './Species/TurkeyJake.svg'
import TurkeyRoost from './Species/TurkeyRoost.svg'
import TurkeyScat from './Species/TurkeyScat.svg'
import TurkeyScratch from './Species/TurkeyScratch.svg'
import TurkeyStrut from './Species/TurkeyStrut.svg'
import TurkeyTom from './Species/TurkeyTom.svg'
import TurkeyTrack from './Species/TurkeyTrack.svg'
import WhitetailDeer from './Species/WhitetailDeer.svg'
import Wolf from './Species/Wolf.svg'

/* Vehicle */
import ATV from './Vehicle/ATV.svg'
import Bike from './Vehicle/Bike.svg'
import Boat from './Vehicle/Boat.svg'
import Horse from './Vehicle/Horse.svg'
import Truck from './Vehicle/Truck.svg'
import Vehicle from './Vehicle/Vehicle.svg'

/* Misc */
import SeeAll from '../svg/Plus.svg'

/*
  #TODO: Grab based on icon keys.
  -- TJC - May 18, 2020
*/
export default {
  Access,
  Antelope,
  Arrow,
  ATV,
  Bedding,
  Bench,
  Bike,
  Bison,
  BlackBear,
  // Blind,
  Blood,
  Boat,
  Boots,
  Buck: MuleDeer,
  Cabin,
  Camp,
  Caribou,
  Chukar,
  CowElk,
  Coyote,
  Crossing,
  Doe: AntlerlessDeer,
  Dog,
  Duck,
  Elk,
  Fish,
  Fishing,
  Food,
  FoodPlot,
  FoodSource,
  Gate,
  Gear,
  Glassing,
  Goose,
  GrizzlyBear,
  GroundBlind,
  Grouse,
  Hazard,
  Horse,
  Javelina,
  Junction,
  LadderStand,
  Llama,
  Moose,
  MtnGoat,
  MtnLion,
  Mushrooms,
  Pack,
  Parking,
  Pheasant,
  Photo,
  PinchPoint,
  PointOfInterest,
  Quail,
  Rub,
  Saddle,
  Sasquatch,
  Scat,
  Scrape,
  Shed,
  Sheep: BHSheep,
  Shot,
  Tracks,
  Trail,
  TrailCam,
  TreeStand,
  Truck,
  TurkeyDusting,
  TurkeyGobble,
  TurkeyHen,
  TurkeyJake,
  TurkeyRoost,
  TurkeyScat,
  TurkeyScratch,
  TurkeyStrut,
  TurkeyTom,
  TurkeyTrack,
  Vehicle,
  Wallow,
  Water,
  Waypoint: GOHUNT,
  WhitetailDeer,
  Wolf,

  // Misc
  SeeAll
}
